const SIGNAL_VALUE = {
    strength: 1,
    neutral: 0.5,
    concern: 0
};
const obj = (v)=>v && typeof v === 'object' && !Array.isArray(v) ? v : {};
const str = (v)=>typeof v === 'string' ? v : '';
function parseSource(json) {
    try {
        return obj(JSON.parse(json));
    } catch  {
        return {};
    }
}
/**
 * Rolls the evaluated answers up for the evaluator. It reads only what was
 * answered: nothing here sets a disposition (QUAL-06), and unknown answers are
 * listed as unknown rather than scored.
 */ export function summarizeQualification(input) {
    const { criteria, answers, basis = {}, suggestions = [] } = input;
    const out = {
        strengths: [],
        concerns: [],
        neutral: [],
        unknowns: [],
        followUps: [],
        warnings: [],
        score: null
    };
    const inputs = [];
    for (const c of criteria){
        const raw = answers[c.id];
        const a = obj(raw);
        const scalar = typeof raw === 'string' && raw.trim() !== '';
        const assessed = scalar || a.state === 'assessed';
        const signal = str(a.signal);
        const b = basis[c.id];
        const source = suggestions.find((s)=>s.id === b?.suggestionId);
        let evidence;
        if (source) {
            const o = parseSource(source.sourceJson);
            evidence = `${str(o.origin) || 'source'} · version ${str(o.version) || 'unknown'} · as of ${str(o.asOf) || 'unknown'}`;
        }
        const item = (text)=>({
                id: c.id,
                label: c.label,
                text,
                evidence
            });
        if (!assessed) {
            const need = str(a.evidenceNeeded);
            out.unknowns.push(item(need ? `Unknown — ${need}` : 'Unknown — open question'));
        } else if (signal === 'strength') out.strengths.push(item(str(a.rationale) || 'Strength'));
        else if (signal === 'concern') out.concerns.push(item(str(a.rationale) || 'Concern'));
        else if (signal === 'neutral') out.neutral.push(item(str(a.rationale) || 'Neutral'));
        else if (!scalar) out.warnings.push(item('Assessed with no signal; not counted as a strength or concern.'));
        const follow = obj(a.followUp);
        if (follow.status === 'open') out.followUps.push(item(`${str(follow.owner)}${follow.dueDate ? ` by ${str(follow.dueDate)}` : ''}${follow.notes ? ` — ${str(follow.notes)}` : ''}`));
        if (b?.needsReview) out.warnings.push(item('Needs review: upstream evidence changed; saved value retained.'));
        if (assessed && a.knowledge === 'hypothesis') out.warnings.push(item('Hypothesis, not confirmed by a source.'));
        for (const s of suggestions)if (s.criterionId === c.id && s.state === 'pending') out.warnings.push(item('A source suggestion is pending review.'));
        if (c.weight && c.weight > 0) {
            const value = assessed && signal in SIGNAL_VALUE ? SIGNAL_VALUE[signal] : null;
            inputs.push({
                id: c.id,
                label: c.label,
                weight: c.weight,
                value,
                explanation: value === null ? assessed ? 'Assessed with no signal — excluded from the score, not counted as 0.' : 'Unknown — excluded from the score, not counted as 0.' : `${signal} (${value}) × weight ${c.weight}`
            });
        }
    }
    if (inputs.length) {
        const known = inputs.filter((i)=>i.value !== null);
        const knownWeight = known.reduce((n, i)=>n + i.weight, 0);
        out.score = {
            percent: knownWeight ? Math.round(known.reduce((n, i)=>n + i.weight * (i.value ?? 0), 0) / knownWeight * 100) : null,
            knownWeight,
            totalWeight: inputs.reduce((n, i)=>n + i.weight, 0),
            inputs
        };
    }
    return out;
}
